import { uniq, uniqBy } from 'lodash';
import {
  fetchUsers,
  getUserById,
  putUser,
  postUser,
} from '../../../mobile/shared/api/users';
import { putDevice } from '../../../mobile/shared/api/devices';
import Auth from '../../amplify';

export const APPEND_USERS = 'APPEND_USERS';
export const REFRESH_USERS = 'REFRESH_USERS';
export const CLEAR_SESSION = 'CLEAR_SESSION';
export const NEW_SESSION = 'NEW_SESSION';
export const REMOVE_USER = 'REMOVE_USER';
export const MERGE_USER = 'MERGE_USER';

export const removeUserById = (payload) => ({ type: REMOVE_USER, payload });

export const getUsers = () => (dispatch) =>
  fetchUsers().then((users) =>
    dispatch({ type: APPEND_USERS, payload: users }),
  );

export const refreshUsers = () => (dispatch) =>
  fetchUsers().then((payload) => dispatch({ type: REFRESH_USERS, payload }));

export const fetchUserById = (id) => (dispatch) =>
  getUserById(id).then((user) =>
    dispatch({ type: APPEND_USERS, payload: [user] }),
  );

export const clearSession = () => ({ type: CLEAR_SESSION });
export const updateSession = (payload) => ({ type: NEW_SESSION, payload });
export const syncUserData = (username) => (dispatch, getState) => {
  const state = getState();
  const userId = username || state.session.username;
  return getUserById(userId).then((user) => {
    dispatch({ type: NEW_SESSION, payload: user });
    return user;
  });
};

export const signup = (form) => (dispatch) => {
  const email = form.emailAddress.toLowerCase();
  return Auth.signUp(email, form.password).then((savedUser) => {
    return Auth.signIn(email, form.password).then(() => {
      delete form.password;
      delete form.confirmPassword;
      const userId = savedUser.userSub;
      return postUser({
        ...form,
        userId,
      }).then(() => {
        return dispatch(syncUserData(userId));
      });
    });
  });
};

export const updateUserDevice = (newDevice) => (dispatch, getState) => {
  const state = getState();
  const user = state.users.session;
  const userDevices = user.devices || [];
  return putDevice(newDevice.deviceId, newDevice).then((savedDevice) => {
    const devices = uniq([savedDevice.deviceId, ...userDevices]);
    const devicesPopulated = uniqBy(
      [savedDevice, ...user.devicesPopulated],
      'deviceId',
    );

    const defaultDeviceId = newDevice.isDefaultDeviceId
      ? savedDevice.deviceId
      : user.defaultDeviceId;
    let promise = Promise.resolve();
    if (
      userDevices.length !== devices.length ||
      defaultDeviceId !== user.defaultDeviceId
    ) {
      promise = putUser(user.userId, { devices, defaultDeviceId });
    }
    return promise.then(() => {
      dispatch({
        type: MERGE_USER,
        payload: {
          defaultDeviceId,
          devices,
          devicesPopulated,
        },
      });
    });
  });
};

export const updateUser = (changes) => (dispatch, getState) => {
  const state = getState();
  const user = state.users.session;
  return putUser(user.userId, changes).then(() => {
    dispatch({ type: MERGE_USER, payload: changes });
  });
};
